import { Injectable } from '@angular/core';

import { MetaData } from '@helper/meta-data';
import { RatingModel } from '../../../rating/rating.model';

@Injectable()
export class ProductInfoModel extends RatingModel {
  override getMetaByUrl(): MetaData | undefined {
    return undefined;
  }
}
